import React from 'react'
import { compose } from 'redux'
import { Button, Modal, ButtonToolbar } from 'reactstrap'
// @ts-ignore
import { Field, reduxForm } from 'redux-form'
import { useTranslation } from 'react-i18next'
import ReactLoading from 'react-loading'

import renderField from 'Containers/Validation/renderField'
import validate from 'Containers/Validation/validate'

interface ModalComponentProps {
  toggle: () => void
  modal: boolean
  handleSubmit: () => void
  isError: boolean
  isLoading: boolean
  pristine: boolean
  submitting: boolean
}

const ModalComponent: React.FunctionComponent<ModalComponentProps> = ({
  toggle,
  modal,
  handleSubmit,
  isError,
  isLoading,
  pristine,
  submitting,
}) => {
  const { t } = useTranslation()

  return (
    <div>
      <Modal
        fade={false}
        className="modal-dialog--danger modal-dialog--header"
        isOpen={modal}
        modalClassName="ltr-support"
        toggle={toggle}
      >
        <div className="modal__header">
          <button
            className="lnr lnr-cross modal__close-btn"
            type="button"
            onClick={toggle}
          />
          <h4 className="text-modal  modal__title">
            {t('settingsPage.deleteYourAccount')}
          </h4>
        </div>
        {!isLoading && !isError && (
          <>
            <div className="modal__body">
              <p>
                {t('settingsPage.areYouSure')}
                <br />
                <span className="bold-text">{t('settingsPage.note')}</span>
                &nbsp;
                {t('settingsPage.ifYouDelete')}
              </p>
              <br />
              <form
                className="form delete-form"
                id="delete-account"
                onSubmit={handleSubmit}
              >
                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('settingsPage.typeDelete')}
                  </span>
                  <div className="form__form-group-field">
                    <Field
                      component={renderField}
                      name="deletion"
                      type="text"
                    />
                  </div>
                </div>
              </form>
            </div>
            <ButtonToolbar className="modal__footer">
              <Button className="modal_cancel" onClick={toggle}>
                {t('settingsPage.cancel')}
              </Button>{' '}
              <Button
                className="modal_ok"
                color="danger"
                disabled={pristine || submitting}
                type="submit"
                form="delete-account"
                onClick={handleSubmit}
              >
                {t('settingsPage.delete')}
              </Button>
            </ButtonToolbar>
          </>
        )}
        {isLoading && (
          <ReactLoading
            className="users-loading loading"
            height={24}
            type="spinningBubbles"
          />
        )}
        {isError && (
          <div className="modal__body">
            <p>{t('settingsPage.contact')}</p>
          </div>
        )}
      </Modal>
    </div>
  )
}

//  eslint-disable-next-line @typescript-eslint/no-explicit-any
export default compose<any>(
  reduxForm({
    form: 'confirmation_form',
    validate,
  })
)(ModalComponent)
